import type { IACListItem } from 'reactApp/modules/folderAccessControlList/folderAccessControlList.types';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

interface Props {
    user?: IACListItem;
    isFolder?: boolean;
    onActionClick(): void;
}

export const renderDeleteUserDialog = (props: Props) => {
    const { onActionClick, user, isFolder } = props;

    openPopupHelper({
        popupName: popupNames.NO_WARNING,
        data: {
            id: 'delete-user-warning-dialog',
            onActionClick,
            title: `Вы действительно хотите отключить доступ для ${user?.email}?`,
            description: `После отключения ${user?.email} не сможет просматривать ${isFolder ? 'эту папку' : 'этот файл'}`,
            buttonAcceptText: 'Отключить',
            buttonRejectText: 'Не отключать',
        },
    });
};
